import type React from "react";
import { useState } from "react";
import SelectionModal from "~/components/Summary/importSelectionModal";
import Button from "~/components/ui/button";
import close from "~/images/close.svg";
import documentIcon from "~/images/documentIcon__onProjectCreated.svg";
import flowChart from "~/images/FlowChart.png";
import styles from "./index.module.scss";

interface ModalProps {
  label: string;
  isOpen: boolean;
  onClose: () => void;
}

const OnProjectCreatedModal: React.FC<ModalProps> = ({ label, onClose }) => {
  const [isSelectionOpen, setIsSelectionOpen] = useState<boolean>(false);

  const handleClose = () => {
    onClose();
    setIsSelectionOpen(false);
  };

  return (
    <div className={styles["overlay"]}>
      <div className={styles["modal"]}>
        <div className={styles["modalTitle"]}>
          <h2>{label}</h2>
          <div className={styles["closeButton"]} onClick={onClose}>
            <img src={close} alt="" />
          </div>
        </div>

        <div className={styles["content"]}>
          <img src={documentIcon} alt="ドキュメント" />
          <h4>
            会議の議事録や文字起こしをアップロードして
            <br />
            ドキュメントを生成しましょう！
          </h4>
          <p>
            アップロードが完了すると議事録が生成され、工程別にドキュメントを
            <br />
            次々と生成できます。
          </p>
          <div className={styles["flowChartContainer"]}>
            <img src={flowChart} alt="フローチャート" className={styles["flowChartImage"]} />
          </div>
          <div className={styles["button"]}>
            <Button
              label={"アップロード"}
              styleType="blue-wide"
              onClick={() => setIsSelectionOpen(true)}
            ></Button>
          </div>
          {isSelectionOpen && <SelectionModal onClose={handleClose} />}
        </div>
      </div>
    </div>
  );
};

export default OnProjectCreatedModal;
